import { Navigate } from 'react-router';
import { LegalPage } from '../../components/legal-page';
import { PRIVACY } from '../../content/legal';
import { countryConfig } from '../../country';
import { ES_LEGAL_PATHS, hasEsLegalSet } from '../../content/legal/es/paths';

/** /privacy — политика конфиденциальности (ЗРУ-547). Public. */
export function Privacy() {
  // MiLicita (`es`) never renders the UZ/KZ policy: its own Spanish policy lives
  // at /privacidad (the router already redirects there; this is the backstop).
  if (hasEsLegalSet(countryConfig.code)) {
    return <Navigate to={ES_LEGAL_PATHS.privacidad} replace />;
  }
  return <LegalPage doc={PRIVACY} canonical="/privacy" />;
}
